module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "load-more"
  }, [_h('span', {
    directives: [{
      name: "show",
      value: (!isLoading),
      expression: "!isLoading"
    }]
  }, ["加载更多···"]), " ", _h('span', {
    directives: [{
      name: "show",
      value: (isLoading),
      expression: "isLoading"
    }],
    staticClass: "loading"
  })])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadMore.vue
 ** module id = 13
 ** module chunks = 1
 **/